import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="progress-bar"
export default class extends Controller {
  static targets = ["label", "bar"]
  static values = {
    increment: { type: Number, default: 0.5 }, // Amount to add per interval
    interval: { type: Number, default: 500 }, // Milliseconds between increments
    max: { type: Number, default: 95 } // Maximum value to reach
  }

  connect() {
    this.startAnimation()
  }

  disconnect() {
    this.stopAnimation()
  }

  getCurrentProgress() {
    const value = this.barTarget.getAttribute("value")
    return value ? parseFloat(value) : 0
  }

  startAnimation() {
    this.intervalId = setInterval(() => {
      const currentProgress = this.getCurrentProgress()

      if (currentProgress < this.maxValue) {
        const newProgress = Math.min(currentProgress + this.incrementValue, this.maxValue)
        this.barTarget.setAttribute("value", newProgress)
        this.labelTarget.textContent = Math.round(newProgress)
      }
    }, this.intervalValue)
  }

  stopAnimation() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }
}
